import React, { useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import { SxProps, Theme } from '@mui/system';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

import { useStore } from 'src/context/StoreContext';
import { getAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';

type InputSearchProps = {
  labelInput?: string;
  name: string;
  value: string;
  readonly?: boolean;
  sx?: SxProps<Theme>;
  onChange?: (value: any | undefined) => void;
  error?: boolean;
};

const InputSearchCustom: React.FC<InputSearchProps> = (props) => {
  const storeContext = useStore();
  const store = storeContext.store;

  const [openSearchPatient, setOpenSearchPatient] = useState(false);
  const [patients, setPatients] = useState([]);
  const loading = openSearchPatient && patients.length === 0;

  const onPatientChange = (e: any, value: any) => {
    props.onChange?.(value);
  };

  const onInputPatientChange = (e: any, value: any) => {
    console.log('vap');
    
    const token = getToken();
    getAPI(`/master/suggest?type=patient&keyword=${value}&token=${token}`)
      .then((res) => {
        if (res.code === 200) {
          setPatients(res.data.result);
        }
      })
      .finally(() => {
        // setCheckAPI(true);
      });
  };

  return (
    <Box>
      {!props.readonly ? (
        <Autocomplete
          id='asynchronous-demo'
          sx={{
            flex: 1,
            backgroundColor: 'primary.light',
            '&.MuiAutocomplete-root .MuiOutlinedInput-root': {
              py: '7px',
              pr: '15px !important',
              width: '160px',
              height: '48px',
            },
            '&.MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input':
            {
              py: 0,
              fontSize: '12px',
            },
            '& .MuiAutocomplete-endAdornment': {
              display: 'none',
            },
            ...props.sx
          }}
          open={openSearchPatient}
          onOpen={() => {
            setOpenSearchPatient(true);
          }}
          onClose={() => {
            setOpenSearchPatient(false);
          }}
          isOptionEqualToValue={(patient: any, value) =>
            patient.fullname === value.fullname
          }
          getOptionLabel={(patient) => patient.fullname}
          options={patients}
          loading={loading}
          onChange={onPatientChange}
          onInputChange={onInputPatientChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label=''
              placeholder={props.labelInput}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      aria-label="search"
                      edge="start"
                      sx={{ width: '24px', height: '24px', ml: '0px', mr: '-5px' }}
                    >
                      <Box
                        component={'img'}
                        src="/images/ic-search.svg"
                        alt="icon search"
                      />
                    </IconButton>
                  </InputAdornment>
                ),
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress color='inherit' size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      ) : (
        <OutlinedInput
          fullWidth
          type='text'
          placeholder={props.labelInput}
          name={props.name}
          value={props.value}
          onChange={() => { }}
          readOnly={props.readonly}
          startAdornment={
            <InputAdornment position='start'>
              <IconButton
                aria-label='search'
                edge='start'
                sx={{ width: '24px', height: '24px', ml: '-4px' }}
              >
                <Box
                  component={'img'}
                  src='/images/ic-search.svg'
                  alt='icon search'
                />
              </IconButton>
            </InputAdornment>
          }
          sx={{
            width: '160px',
            height: '48px',
            '& .MuiOutlinedInput-notchedOutline': { borderColor: props.error ? '#d32f2f !important' : '#BDBDBD' },
            '& .MuiInputBase-input': { p: '12px 16px 12px 0px' },
            '& input::placeholder': {
              fontSize: '12px',
              fontWeight: 400,
              color: '#AAB2BD',
              opacity: 1,
            },
            backgroundColor: store.palette.input.bgColor,
            ...props.sx
          }}
          inputProps={{
            sx: {
              fontSize: '12px',
              fontWeight: 400,
              color: store.palette.input.color,
              backgroundColor: store.palette.input.bgColor,
            },
          }}
        />
      )}
    </Box>
  );
}

export default InputSearchCustom;
